<!--
* 组件名 : 海报
* 开发者 : JY
*
* 参数:
*   posters     { Object } -  书籍数据
*
* 事件:
*   openVideoPlayer [] - 打开视频播放器
*
*
-->

<template>
  <div class="v-posters d-flex">
    <div class="poster-items" v-for="(item, i) in posters.data" :key="i">
      <div
        class="poster-video-card"
        @click="on_open_player(item.vid, item.description)"
      >
        <div class="card-cover">
          <img :src="item.img" :alt="item.title" />
          <v-btn><v-icon>play_circle_outline</v-icon></v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "posters",
  props: {
    posters: {
      type: Object,
      required: true,
    },
  },
  methods: {
    on_open_player(vid, desc) {
      this.$videoPlayer({ vid, desc });
    },
  },
};
</script>

<style lang="scss">
.v-posters {
  justify-content: center;

  .poster-items {
    margin: 0 16px;
  }

  @media (max-width: $lx-min) {
    .poster-video-card {
      width: 240px;
    }
  }
}

.poster-video-card {
  width: 280px;
  margin-right: 32px;

  &:nth-last-of-type(1) {
    margin-right: 0;
  }

  .card-cover {
    padding-top: 139.52%;

    .v-btn {
      left: 16px;
      bottom: 16px;

      i {
        font-size: 38px;
      }
    }
  }
}
</style>
